import React from 'react';
import { cn } from '@/lib/utils';
import { FormattedText } from '@/components/ui/formatted-text';

interface MarkdownDescriptionProps {
  content: string;
  className?: string;
  textColor?: string;
}

export const MarkdownDescription: React.FC<MarkdownDescriptionProps> = ({ 
  content, 
  className,
  textColor
}) => {
  if (!content?.trim()) return null;

  return (
    <div
      className={cn(
        'flex-col prose prose-lg max-w-none prose-p:leading-relaxed prose-p:my-2 prose-strong:font-semibold prose-a:no-underline hover:prose-a:underline [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 prose-p:!text-inherit prose-strong:!text-inherit prose-a:!text-inherit hidden md:flex',
        className
      )}
      style={{ color: 'inherit' }}
    >
      <FormattedText text={content} textColor={textColor} />
    </div>
  );
};
